import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import gameData from '../gameData';

export default class ScoreBox extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;

    this.scoreNum = 0;
    this.scoreTxt = ABCyaPhaser.Text.addText(0, 0, 24, '0xFFFFFF', FontKeys._odin_roundedregular, `SCORE: ${this.scoreNum}`, this, false);

    this.targetTxt = ABCyaPhaser.Text.addText(0, 0, 24, '0xFFFFFF', FontKeys._odin_roundedregular, `TARGET NUMBER: ${gameData.addNum}`, this, false);
    this.targetTxt.y = this.scoreTxt.y + this.targetTxt.height + 5;

    this.bottomBorder = ABCyaPhaser.Images.addImage(0, 0, 'leaf-1', this).setOrigin(0, 0);
    this.bottomBorder.y = this.targetTxt.y + 25;
  }

  updateScore(num) {
    this.scoreNum = num;
    this.scoreTxt.text = `Score: ${this.scoreNum.toString()}`;
  };
}